import Statistics from "../components/Dashboard/Dashboard";

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    redirect: "/manuscripts/submitted",
    component: Statistics,
    meta: { requiresAuth: true, description: "Dashboard" },
  },
];

export default routes;
